import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createVNode as _createVNode } from "vue"

const _hoisted_1 = { id: "nav-level1" }
const _hoisted_2 = { class: "toggle-button-item" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "bar" }, null, -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-tachometer-alt" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "nav-hint" }, "Dashboard", -1)
const _hoisted_7 = { class: "nav-hint" }
const _hoisted_8 = {
  key: 0,
  class: "fa fa-user color-white",
  style: {"font-size":"18px"}
}
const _hoisted_9 = {
  class: "nav-hint user-info flex flex-column",
  style: {"width":"auto"}
}
const _hoisted_10 = { style: {"white-space":"nowrap"} }
const _hoisted_11 = { class: "language-options" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("ul", null, [
      _createElementVNode("li", _hoisted_2, [
        _createElementVNode("div", {
          class: "toggle-button",
          href: "#",
          onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleMenu && _ctx.toggleMenu(...args)), ["prevent"]))
        }, _hoisted_4)
      ]),
      _createElementVNode("li", null, [
        (!(_ctx.authState.state.organization?.is_system ?? false))
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 0,
              class: "nav-hint-parent",
              to: _ctx.RouteHelper.getLink('dashboard/ca')
            }, {
              default: _withCtx(() => [
                _hoisted_5,
                _hoisted_6
              ]),
              _: 1
            }, 8, ["to"]))
          : _createCommentVNode("", true)
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mainMenu, (item, idx) => {
        return (_openBlock(), _createElementBlock("li", { key: idx }, [
          _createVNode(_component_router_link, {
            class: "nav-hint-parent",
            to: _ctx.RouteHelper.getLink(item.link)
          }, {
            default: _withCtx(() => [
              _createElementVNode("i", {
                class: _normalizeClass('fas fa-' + item.icon)
              }, null, 2),
              _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t(item.name)), 1)
            ]),
            _: 2
          }, 1032, ["to"])
        ]))
      }), 128)),
      _createElementVNode("li", null, [
        _createVNode(_component_router_link, {
          class: "nav-hint-parent",
          to: _ctx.RouteHelper.getLink(`account/${(_ctx.authState.state.organization?.is_system ?? false) ? 'activelicenses' : 'credentials'}`)
        }, {
          default: _withCtx(() => [
            (!_ctx.authState.state.globalUser?.pictureContent)
              ? (_openBlock(), _createElementBlock("i", _hoisted_8))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t('welcome-globaluser', { name: _ctx.authState.state.globalUser?.name })), 1),
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_Button, {
                  label: "FR",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeLanguage('fr'))),
                  class: "p-button-link"
                }),
                _createVNode(_component_Button, {
                  label: "EN",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.changeLanguage('en'))),
                  class: "p-button-link"
                }),
                _createVNode(_component_Button, {
                  label: "NL",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.changeLanguage('nl'))),
                  class: "p-button-link"
                })
              ]),
              _createVNode(_component_Button, {
                class: "p-button-outlined",
                label: _ctx.$t('logout'),
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.logout()))
              }, null, 8, ["label"])
            ])
          ]),
          _: 1
        }, 8, ["to"])
      ])
    ])
  ]))
}